import { SpotSwiperSlide } from '@/components/molecules/spots/SpotSwiperSlide'
import { useCampaignSlug } from '@/lib/useCampaignSlug'
import type { RootState } from '@/store/store'
import Link from 'next/link'
import React, { useState, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Pagination, Virtual } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

interface SpotInSheetCardProps extends Api.SpotInSheetObject {
  slideIndex: number
}

const SwiperGoogleMap = ({
  spotInSheet,
}: {
  spotInSheet: Api.SpotInSheetObject[]
}) => {
  const { gen } = useCampaignSlug()
  const [swiperArrayState, setSwiperMapArrayState] = useState<boolean>(false)
  const [spotInSheetToSwiper, setSpotInSheetToSwiper] = useState<SpotInSheetCardProps[]>([])

  const slideStateSelector = useSelector((state: RootState) => state.spotMap.slideIndex)
  const slideIndexOnClickAtSelector = useSelector((state: RootState) => state.spotMap.slideIndexOnClickAt)
  const spotIdToSliceIndexSelector = useSelector((state: RootState) => state.spotMap.spotIdToSliceIndex)

  const ref = useRef(null)

  useEffect(() => {
    setSwiperMapArrayState(false)
    setTimeout(() => {
      setSwiperMapArrayState(true)
    }, 0)

    return
  }, [spotInSheet])

  useEffect(() => {
    if (ref.current?.swiper) {
      ref.current.swiper.slideTo(Number(slideStateSelector))
    }
    return
  }, [slideStateSelector, slideIndexOnClickAtSelector])

  useEffect(() => {
    const spotIdsInClusteredIds = spotIdToSliceIndexSelector.map((v) => v.spotId)
    setSpotInSheetToSwiper(
      spotInSheet
        .filter((v) => spotIdsInClusteredIds.includes(v.id))
        .map((v) => {
          const targetSpot = spotIdToSliceIndexSelector.filter((s) => s.spotId === v.id)[0]
          return {
            ...v,
            slideIndex: targetSpot.sliceIndex,
          }
        }),
    )
    if (ref.current?.swiper) {
      ref.current.swiper.slideTo(0)
    }

    setSwiperMapArrayState(false)
    setTimeout(() => {
      setSwiperMapArrayState(true)
    }, 0)
  }, [spotIdToSliceIndexSelector])

  return (
    <div className="c-swiper_map-wrap">
      {swiperArrayState ? (
        <Swiper
          modules={[Virtual, Pagination]}
          loop={false}
          speed={1000}
          spaceBetween={10}
          slidesPerView={1.35}
          centeredSlides={true}
          ref={ref}
          virtual
        >
          {spotInSheetToSwiper.map((content, i: number) => {
            return (
              <SwiperSlide key={content.id} virtualIndex={content.id}>
                <Link
                  href={{
                    pathname: gen('/spot/detail/'),
                    query: {
                      query: content.id,
                    },
                  }}
                >
                  <SpotSwiperSlide
                    name={content.name}
                    image={content.image}
                    address={content.address}
                    isStamp={content.isStamp}
                    sheetNames={content.sheetNames}
                    isCoupon={content.isCoupon}
                    stamp={content.stamp}
                    stampStatus={content.stampStatus}
                    spotCrowded={content.crowded}
                  />
                </Link>
              </SwiperSlide>
            )
          })}
        </Swiper>
      ) : (
        <></>
      )}
    </div>
  )
}

export default SwiperGoogleMap
